import React from 'react'
import { createRoot } from 'react-dom/client'
import { Router } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import { ThemeProvider } from 'styled-components'
import { initAuth } from '@hssoft/auth-web-shared-lib'

import { history } from 'config/history'
import theme from 'config/theme'
import config, { cookieStorageOptions } from 'config/aws'
import useApolloClient from 'hooks/useApolloClient'
import withAuth from 'components/withAuth'
import ErrorHandler from 'components/ErrorHandler'

import App from './App'

import './i18n/init'
import 'style/index.scss'
import 'weather-icons/css/weather-icons.min.css'
import 'moment/locale/de'

// window.LOG_LEVEL = 'DEBUG'

/* configures Amplify (Auth) and the shared cookie token storage for .hssoft.com SSO */
initAuth(config, {
	cookieStorage: {
		domain: cookieStorageOptions.domain,
		secure: cookieStorageOptions.secure,
		expires: cookieStorageOptions.expires
	},
	/* required for the MFA "trust this device" option on the login screen */
	enableDeviceTracking: true
})

const Index = () => {
	const { client, isLoading } = useApolloClient()
	return !isLoading && (
		<ThemeProvider theme={theme}>
			<ApolloProvider client={client}>
				<Router history={history}>
					<ErrorHandler client={client}>
						<App/>
					</ErrorHandler>
				</Router>
			</ApolloProvider>
		</ThemeProvider>
	)
}

const AuthIndex = withAuth(Index)

const root = createRoot(document.getElementById('root'))
root.render(<AuthIndex/>)

